import { Customer, CustomerType, UserType } from '../types'

export const getCustomer = (
    userType: UserType | undefined,
    customers: Customer[]
): Customer | undefined => {
    if (!userType) {
        return
    }

    if (userType === UserType.CUSTOMER) {
        return customers[0]
    }

    if (userType === UserType.AGENT) {
        const agencyCustomer = customers.find(
            (c) => c.type === CustomerType.AGENCY
        )
        return agencyCustomer
    }

    const brokerCustomer = customers.find((c) => c.type === CustomerType.BROKER)
    return brokerCustomer
}
